import { api } from './client'
import type { FishermanProfile, ProfileUpdate, ProfileUpdateResult } from './types'

export function getMyProfile(): Promise<FishermanProfile> {
  return api.get<FishermanProfile>('/me')
}

export function updateMyProfile(patch: ProfileUpdate): Promise<ProfileUpdateResult> {
  return api.patch<ProfileUpdateResult>('/me', patch)
}
